import state from "../state";
import SyntheticVoiceApi from "../speech/SyntheticVoiceApi";

export function showPromptModal(text, affirmativeAction, negativeAction, options) {
	// console.log("Show prompt modal", text);
	state.set(["appState", "promptModal", "text"], text);
	state.set(["appState", "promptModal", "affirmativeAction"], affirmativeAction);
	state.set(["appState", "promptModal", "negativeAction"], negativeAction);
	state.set(["appState", "promptModal", "options"], options);
	state.set(["appState", "promptModal", "visible"], true);
	setTimeout(() => {
		try {
			SyntheticVoiceApi.stop();
		} catch (e) {
			console.warn(e);
		}
		SyntheticVoiceApi.speak(text);
	}, 100);
}

export function hidePromptModal() {
	state.unset(["appState", "promptModal", "text"]);
	state.unset(["appState", "promptModal", "options"]);
	state.unset(["appState", "promptModal", "affirmativeAction"]);
	state.unset(["appState", "promptModal", "negativeAction"]);
	state.set(["appState", "promptModal", "visible"], false);
}

export function isPromptModalVisible() {
	return state.get(["appState", "promptModal", "visible"]);
}